import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/platform.css'
import App from './App.vue'
import router from './router'
import store from './store'
import http from './utils/httpRequest'
import { isAuth } from './utils'

Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.$http = http
Vue.prototype.isAuth = isAuth

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
